export const createTranslation = (
  literal: string,
  t: (literal: string) => string,
  country?: string,
  vars?: { [key: string]: any },
) => {
  const tr = translate(literal, t, country);

  if (!!vars) {
    return Object.entries(vars).reduce(
      (acc, [k, v]) => acc.replace(`{${k}}`, v?.toString() || ''),
      tr,
    );
  }

  return tr;
};

const translate = (
  literal: string,
  t: (literal: string) => string,
  country?: string,
) => {
  if (!country) {
    return t(literal);
  }

  const nl = `${literal}-${country}`;
  const cl = t(nl);

  return cl === nl ? t(literal) : cl;
};
